module.exports = __webpack_public_path__ + "static/img/fish44.f5c95da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish44.png
// module id = 7OSN
// module chunks = 0